@if (cloudStatus) {
  <app-cloud-status [status]="currentCloudStatus"></app-cloud-status>
}
@if (cloudStatus && showStatusDialog) {
  <app-cloud-status-dialog [status]="currentCloudStatus"></app-cloud-status-dialog>
}

<div class="d-flex flex-row align-items-center mb-3 ml-3 mr-3">
    <div class="h3">{{ "support_ticket_list_headline" | i18next }}</div>
    <div class="ml-auto bd-highlight">
        <button name="add-ticket" class="btn btn-outline-primary" [routerLink]="['/supportV2/ticket/create']">{{
            'support_ticket_add_button' | i18next }}</button>
        
    </div>
</div>

<app-filter (searchFilterChanged)="doFilter($event)"
  [placeholder]="'support_ticket_search_placeholder' | i18next"
  (checkboxFilterChanged)="showClosedTickets($event)"
  filterType="checkbox"
  [checkboxFilterText]="'filter_closed_tickets_text' | i18next">
</app-filter>

@if (currentTicketsToDisplay && currentTicketsToDisplay.length === 0) {
<app-no-content-message t="no_tickets"></app-no-content-message>
}

<div class="row align-items-stretch mt-4 mb-3">
    @for (item of currentTicketsToDisplay; track (item.source === 'v2' ? item.ticket.ticketId : item.ticket.id)) {
        @if (item.source === 'v2') {
            <app-ticket-card-v2 class="col-xs-12 col-md-6 col-lg-6 mb-3" [ticket]="item.ticket"
                [applianceId]="item.ticket.applianceId.toString()"></app-ticket-card-v2>
        } @else {
            <app-ticket-card class="col-xs-12 col-md-6 col-lg-6 mb-3" [ticket]="item.ticket"
                [applianceName]="getSubscriptionName(item.ticket.applianceId)"></app-ticket-card>
        }
    }
</div>

@if (needsPagination) {
  <div class="d-flex justify-content-center mb-3">
    <button (click)="nextPage()" name="load-more-ticket" class="btn btn-outline-primary">{{ 'support_ticket_load_more_button' | i18next }}</button>
  </div>
}
